var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseButton"},[_c(_vm.isTag,{ref:"button",tag:"component",staticClass:"baseButton__button",class:[
      {disabled : _vm.isDisabled},
      _vm.design !== '' ? 'baseButton__button--' + _vm.design : ''
    ],on:{"click":_vm.clicked}},[_c('span',{staticClass:"baseButton__button__label",class:{disabled : _vm.isDisabled && !_vm.btnLabelEnable}},[_vm._v(_vm._s(_vm.label)+"\n    ")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c016422","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/common/BaseButton.vue
// module id = null
// module chunks = 